
import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
// Import all images statically
import carousel8 from '../imagProps/carousel/carousel8.jpg';
import carousel_mo_5 from '../imagProps/carousel/carousel_mo_5.jpg'
import carousel9 from '../imagProps/carousel/carousel9.jpg';
import carousel_mo_6 from '../imagProps/carousel/carousel_mo_6.jpg'
import carousel10 from '../imagProps/carousel/carousel10.jpg';
import carousel_mo_1 from '../imagProps/carousel/1_mo.webp'
import carousel11 from '../imagProps/carousel/2_land.avif';
import carousel_mo_3 from '../imagProps/carousel/carousel_mo_3.JPG'
import carousel_mo_2 from '../imagProps/carousel/2_land.avif'
import carousel12 from '../imagProps/carousel/1.webp';
import replicon from '../imagProps/carousel/replicon.png';
import code_surge from '../imagProps/carousel/code_surge.jpg';
import webthonCarousel from '../imagProps/carousel/webthon2.png';
import webthonMo from '../imagProps/carousel/webthon2_mo.png';

/* Home Page Carousel */


function Cover() {
  const props = [
    {
      imgPath: webthonCarousel,       // Desktop/laptop
      imgTablet: webthonMo,     // Tablet - using laptop images
      imgMobile: webthonMo,  // Mobile - using mobile images
      desc: 'Webathon 2.0'
    },
    {
      imgPath: carousel8,        // Desktop/laptop
      imgTablet: carousel8,      // Tablet - using laptop images
      imgMobile: carousel_mo_6,  // Mobile - using mobile images
      desc: 'WCC 4.0'
    },
    {
      imgPath: carousel9,       // Desktop/laptop
      imgTablet: carousel9,     // Tablet - using laptop images
      imgMobile: carousel_mo_3,  // Mobile - using mobile images
      desc: 'Tech Spectrum'
    },
    {
      imgPath: carousel10, // Desktop/laptop
      imgTablet: carousel10,     // Tablet - using laptop images
      imgMobile: carousel_mo_5,  // Mobile - using mobile images
      desc: 'Webathon 3.0'
    },
    {
      imgPath: carousel12,       // Desktop/laptop
      imgTablet: carousel12,     // Tablet - using laptop images
      imgMobile: carousel_mo_1,  // Mobile - using mobile images
      desc: 'Agentic AI'
    },     
  ];
  
  return (
    <div className="w-full">
      <div className="w-full mx-auto">
        <Carousel 
          autoPlay={true} 
          infiniteLoop={true} 
          showThumbs={false} 
          showArrows={false} 
          showStatus={false} 
          swipeable={true}
          interval={5000}
          className="w-full"
        >
          {props.map((content, idx) => (
            <div key={idx} className="relative w-full">
              <div className="relative w-full h-[40vh] sm:h-[66vh] md:h-[90vh]">
                <picture>
                  {/* Mobile breakpoints - using mobile images for all mobile sizes */}
                  <source 
                    media="(max-width: 780px)" 
                    srcSet={content.imgMobile} 
                  />
                  {/* Tablet breakpoint - using laptop images */}
                  <source 
                    media="(max-width: 1024px)" 
                    srcSet={content.imgTablet} 
                  />
                  {/* Desktop - default laptop images */}
                  <img 
                    src={content.imgPath} 
                    alt={content.desc}
                    loading="lazy"
                    decoding='async'
                    className='h-full w-full object-fill'
                    />
                </picture>
                <div className="absolute inset-0"></div>
                <div className="absolute 
                  bottom-6 left-4 right-auto
                  text-white font-bold 
                  text-lg sm:text-3xl md:text-4xl
                  z-10
                  p-2 sm:p-4
                  md:bottom-7 md:left-24 
                  md:text-right md:max-w-[40%] drop-shadow-lg">
                  {content.desc}
                </div>
              </div>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
}

export default Cover;





// import { useState, useEffect, useRef } from 'react';
// import { ChevronLeft, ChevronRight } from 'lucide-react';

// const Cover = () => {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const autoPlayRef = useRef(null);
  
//   // Sample images - replace with your own
  

//   const nextSlide = () => {
//     setCurrentIndex(prevIndex => 
//       prevIndex === slides.length - 1 ? 0 : prevIndex + 1
//     );
//   };

//   const prevSlide = () => {
//     setCurrentIndex(prevIndex => 
//       prevIndex === 0 ? slides.length - 1 : prevIndex - 1
//     );
//   };

//   const goToSlide = (index) => {
//     setCurrentIndex(index);
//   };

//   useEffect(() => {
//     autoPlayRef.current = setInterval(() => {
//       nextSlide();
//     }, 5000);
    
//     return () => {
//       if (autoPlayRef.current) {
//         clearInterval(autoPlayRef.current);
//       }
//     };
//   }, []);



//   return (
//     <div className="relative w-full max-w-4xl mx-auto overflow-hidden rounded-lg shadow-lg">
//       {/* Main carousel */}
//       <div className="relative w-full h-64 md:h-96">
//         {slides.map((slide, index) => (
//           <div
//             key={slide.id}
//             className={`absolute top-0 left-0 w-full h-full transition-all duration-700 ease-in-out transform ${
//               index === currentIndex 
//                 ? 'opacity-100 translate-x-0' 
//                 : index < currentIndex 
//                   ? 'opacity-0 -translate-x-full' 
//                   : 'opacity-0 translate-x-full'
//             }`}
//           >
//             <img 
//               src={slide.src} 
//               alt={slide.alt} 
//               className="object-cover w-full h-full"
//             />
//             <div className="absolute bottom-0 w-full p-4 bg-gradient-to-t from-black to-transparent">
//               <h3 className="text-xl font-bold text-white">{slide.title}</h3>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Navigation arrows */}
//       <button 
//         onClick={prevSlide}
//         className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-all duration-300"
//         aria-label="Previous slide"
//       >
//         <ChevronLeft size={24} />
//       </button>
      
//       <button 
//         onClick={nextSlide}
//         className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-all duration-300"
//         aria-label="Next slide"
//       >
//         <ChevronRight size={24} />
//       </button>

//       {/* Dots indicators */}
//       <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
//         {slides.map((_, index) => (
//           <button
//             key={index}
//             onClick={() => goToSlide(index)}
//             className={`w-3 h-3 rounded-full transition-all ${
//               index === currentIndex ? 'bg-white scale-125' : 'bg-white/50 hover:bg-white/80'
//             }`}
//             aria-label={`Go to slide ${index + 1}`}
//           />
//         ))}
//       </div>


//     </div>
//   );
// };

// export default Cover;



// import { useState, useEffect, useRef } from 'react';


// const Cover = () => {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const autoPlayRef = useRef(null);
  
//   // Using your provided slides
//   const slides = [
//     {
//       id: 1,
//       src: '../imagProps/carousel/carousel8.jpg',
//       alt: "WCC 4.0",
//       title: "WCC 4.0"
//     },
//     {
//       id: 2,
//       src: "../imagProps/carousel/carousel9.jpg",
//       alt: "Tech Spectrum",
//       title: "Tech Spectrum"
//     },
//     {
//       id: 3,
//       src: "../imagProps/carousel/carousel10.jpg",
//       alt: "Webathon 3.0",
//       title: "Webathon 3.0"
//     },
//     {
//       id: 4,
//       src: "../imagProps/carousel/carousel11.jpg",
//       alt: "Stack Track",
//       title: "Stack Track"
//     },
//     {
//       id: 5,
//       src: "../imagProps/carousel/carousel6.jpeg",
//       alt: "Webathon",
//       title: "Webathon"
//     },
//   ];
  
//   const nextSlide = () => {
//     setCurrentIndex(prevIndex => 
//       prevIndex === slides.length - 1 ? 0 : prevIndex + 1
//     );
//   };

//   const prevSlide = () => {
//     setCurrentIndex(prevIndex => 
//       prevIndex === 0 ? slides.length - 1 : prevIndex - 1
//     );
//   };

//   const goToSlide = (index) => {
//     setCurrentIndex(index);
//   };

//   useEffect(() => {
//     autoPlayRef.current = setInterval(() => {
//       nextSlide();
//     }, 5000);
    
//     return () => {
//       if (autoPlayRef.current) {
//         clearInterval(autoPlayRef.current);
//       }
//     };
//   }, []);

//   return (
//     <div className="relative w-full sm:w-2/3 md:w-3/5 lg:w-full mx-auto overflow-hidden rounded-lg shadow-lg">
//       {/* Main carousel */}
      
//       <div className="relative w-full h-48 sm:h-56 md:h-64 lg:h-96">
//         {slides.map((slide, index) => (
//           <div
//             key={slide.id}
//             className={`absolute top-0 left-0 w-full h-full transition-all duration-700 ease-in-out transform ${
//               index === currentIndex 
//                 ? 'opacity-100 translate-x-0' 
//                 : index < currentIndex 
//                   ? 'opacity-0 -translate-x-full' 
//                   : 'opacity-0 translate-x-full'
//             }`}
//           >
//             <img 
//               src={slide.src} 
//               alt={slide.alt} 
//               className="object-cover w-full h-full"
//             />
//             <div className="absolute bottom-0 w-full p-4 bg-gradient-to-t from-black to-transparent">
//               <h3 className="text-xl font-bold text-white">{slide.title}</h3>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Navigation arrows */}
//       <button 
//         onClick={prevSlide}
//         className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-all duration-300"
//         aria-label="Previous slide"
//       >
//         <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
//         </svg>
//       </button>
      
//       <button 
//         onClick={nextSlide}
//         className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-all duration-300"
//         aria-label="Next slide"
//       >
//         <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
//         </svg>
//       </button>

//       {/* Dots indicators */}
//       <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
//         {slides.map((_, index) => (
//           <button
//             key={index}
//             onClick={() => goToSlide(index)}
//             className={`w-3 h-3 rounded-full transition-all ${
//               index === currentIndex ? 'bg-white scale-125' : 'bg-white/50 hover:bg-white/80'
//             }`}
//             aria-label={`Go to slide ${index + 1}`}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Cover;